/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */


import * as Yup from "yup";

export const signupSchema = Yup.object().shape({
  name: Yup.string()
    .required("Name is required")
    .matches(/^[a-zA-Z\s]+$/, "Only alphabetic characters and spaces allowed")
   .max(30, "Maximum 30 characters"),
  email: Yup.string()
    .email("Invalid email format")
    .test("domain", "Invalid domain name", (value) => {
      const domain = value?.split("@")[1];
      if (!domain) return false;
      const domainRegex = /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return domainRegex.test(domain);
    })
    .min(3, "Minimum 3 symbols")
    .max(50, "Maximum 50 symbols")
    .required("Email is required"),

  password: Yup.string()
    .required("Password is required")
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
      "Password must contain at least one uppercase, one lowercase, one number, one special character, and be 8+ characters"
    ),
});
   export const loginSchema = Yup.object().shape({
    email: Yup.string()
      .email("Wrong email format")
      .min(3, "Minimum 3 symbols")
      .max(50, "Maximum 50 symbols")
      .required("Email is required"),

    password: Yup.string()
      .min(3, "Minimum 3 symbols")
      .max(50, "Maximum 50 symbols")
      .required("Password is required"),
  });


export const validationSchema = Yup.object().shape({
  mobileNumber: Yup.string()
    .matches(/^\d{10}$/, "Mobile number should contain exactly 10 numbers")
    .test(
      "no-repeating-digits",
      "Mobile number cannot have repeating 6 consecutive digits",
      (value: string | undefined) => {
        if (!value) return true;
        for (let i = 0; i <= value.length - 6; i++) {
          if (new Set(value.substring(i, i + 6)).size === 1) {
            return false;
          }
        }
        return true;
      }
    )
    .required("Mobile Number is required"),

  otp1: Yup.string()
    .matches(/^\d$/, "OTP must be a digit")
    .required("OTP is required"),

  otp2: Yup.string()
    .matches(/^\d$/, "OTP must be a digit")
    .required("OTP is required"),

  otp3: Yup.string()
    .matches(/^\d$/, "OTP must be a digit")
    .required("OTP is required"),

  otp4: Yup.string()
    .matches(/^\d$/, "OTP must be a digit")
    .required("OTP is required"),

  otp5: Yup.string()
    .matches(/^\d$/, "OTP must be a digit")
    .required("OTP is required"),

  otp6: Yup.string()
    .matches(/^\d$/, "OTP must be a digit")
    .required("OTP is required"),
});
